import styles from './Manual.module.sass'
import '../../styles/global.sass'
import ManualUsuari from '../../assets/ilustrations/ManualUsuari.png'
import ManualUsuariAcces from '../../assets/ilustrations/ManualUsuariAcces.png'

function Manual() {
    return (
        <div className={styles.container}>
            <div className='margin_top'></div>
            <div className='container'>

                <h1>Com buscar un document?</h1>

                <div className={styles.section}>
                    <div className={styles.p1}>
                        Cerca temàtica
                    </div>
                    <div className={styles.body_regular}>
                        Permet realitzar cerques específiques seleccionant matèries i organismes concrets entre tots els documents publicats al BOPA, des de l'1 de gener de 1989 fins a l’actualitat.
                        <p></p>
                        És recomanable acotar la cerca per data de publicació. Es pot seleccionar mitjançant el calendari o introduir-la amb el format “dd/mm/aaaa”.
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.p1}>
                        Cerca per paraules
                    </div>
                    <div className={styles.body_regular}>
                        Permet trobar qualsevol paraula inclosa dins els documents publicats.
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.p1}>
                        Regles generals per a la cerca:
                    </div>
                    <div className={styles.body_regular}>
                        <ol className={styles.body_regular}>
                            <li className={styles.body_regular}>Les paraules es poden introduir en majúscules o minúscules indistintament, i amb o sense accent o dièresis. D’aquesta manera el resultat de la recerca serà el mateix si s'escriu: "DISPOSICIÓ", "DISPOSICIO", "disposició" o “disposicio". Cal tenir en compte que, excepte pels supòsits establerts en l’apartat anterior, les paraules introduïdes es cerquen de forma exacta. Per exemple, si introduïm "dispo" no trobarem la paraula "disposició".</li>
                            <li className={styles.body_regular}>També es poden escriure les paraules entre cometes i així fer que la cerca sigui exacta.</li>
                            <li className={styles.body_regular}>Es poden utilitzar els condicionants de Google com el “AND” amb el símbol +, “OR” amb la barra | (altGr) i la tecla 1, o “NOT” amb el símbol - per acotar encara més la cerca.</li>
                        </ol>
                        <p></p>
                        El resultat es mostra per el document amb més rellevància, per data i per ordre protocol·lari.
                    </div>
                </div>
                
                <div className={styles.section}>
                    <div className={styles.p1}>
                    Com buscar un BOPA concret?
                    </div>
                    <div className={styles.body_regular}>
                    Clica a “Butlletins” i busca la publicació, o bé a través del calendari. Estan per ordre cronològic descendent, és a dir el més actual primer.
                    </div>
                    <p></p>
                    <img src={ManualUsuari} />
                </div>

                <div className={styles.section}>
                    <div className={styles.p1}>
                    Espai personal: Accés usuari
                    </div>
                    <p></p>
                    <img src={ManualUsuariAcces} />
                    <div className={styles.body_regular}>
                    És un servei gratuït que t'ofereix la possibilitat de rebre, per correu electrònic, aquells documents que siguin del teu interès, el mateix dia que es publiquen, com concursos públics, oferta de de treball, subhastes, etc...
                    </div>
                    <p></p>
                    <div className={styles.body_regular}>
                    Segueix els passos següents:
                    <ol className={styles.body_regular}>
                        <li className={styles.body_regular}>Selecciona l'Organisme i/o el Tema del qual vols rebre notificacions.</li>
                        <li className={styles.body_regular}>Marca el quadrat de l'apartat que t'interessa fent un clic.</li>
                    </ol>
                    Guarda les teves cerques, i guarda documents com a favorits.
                    <p></p>
                    Registrat com a usuari: 
                    <b> Per accedir al seu espai personal “accés a l’usuari” s’ha d’entrar o bé amb el seu compte de Microsoft (Hotmail) o Google (gmail).</b>
                    </div>
                </div>
            </div>
        </div>          
    )
}

export default Manual